function resolveMessageDate(message) {
    if (!message || typeof message !== 'object') return null;

    const serverTimestamp = String(message.server_timestamp || '').trim();
    if (serverTimestamp) {
        const parsedServerTimestamp = Date.parse(serverTimestamp);
        if (Number.isFinite(parsedServerTimestamp)) {
            return new Date(parsedServerTimestamp);
        }
    }

    const rawTimestamp = message.timestamp;
    if (rawTimestamp === undefined || rawTimestamp === null || rawTimestamp === '') {
        return null;
    }

    const numericTimestamp = typeof rawTimestamp === 'number'
        ? rawTimestamp
        : Number(String(rawTimestamp).trim());
    if (!Number.isFinite(numericTimestamp)) return null;

    const date = new Date(numericTimestamp);
    return Number.isNaN(date.getTime()) ? null : date;
}

function formatLocalTimeWithAmPm(date) {
    const formatter = new Intl.DateTimeFormat(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });
    const parts = formatter.formatToParts(date);
    const hour = parts.find((part) => part.type === 'hour')?.value || '';
    const minute = parts.find((part) => part.type === 'minute')?.value || '';
    const separator = parts.find((part, index) => (
        part.type === 'literal'
        && parts[index - 1]?.type === 'hour'
        && parts[index + 1]?.type === 'minute'
    ))?.value || ':';
    if (!hour || !minute) {
        return formatter.format(date);
    }
    return `${hour}${separator}${minute} ${date.getHours() < 12 ? 'AM' : 'PM'}`;
}

export function formatMessageDateTime(message) {
    const date = resolveMessageDate(message);
    if (!date) return '';

    const dateLabel = new Intl.DateTimeFormat(undefined, {
        day: 'numeric',
        month: 'short',
    }).format(date);
    return `${dateLabel}, ${formatLocalTimeWithAmPm(date)}`;
}
